import { Product } from '../types';

// ============================================
// SPECIAL UNIVERSAL CONNECTORS - 3 & 4 POLE
// ============================================

// 3 POLE SPECIAL CONNECTORS
export const specialConnector3PoleProducts: Product[] = [
  {
    id: "special-conn-erickshaw-socket-3p-f",
    name: "E-Rickshaw Socket 3 Pole Female",
    slug: "special-erickshaw-socket-3-pole-female",
    category: "Special Universal Connectors",
    subcategory: "3 Pole Connectors",
    description: "E-Rickshaw socket 3 pole female connector with 4mm deluxe wire.",
    partNumber: "SH2100301",
    image: "/products/special-universal-connectors/special-universal/SH2100301.jpg",
    featured: true,
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Compatible": "E-Rickshaw Socket",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "3-pole", "e-rickshaw", "socket", "female"],
    applications: ["E-Rickshaw", "3-Wheeler"],
  },
  {
    id: "special-conn-al-3p-f-5-8mm",
    name: "Universal Ashok Leyland 3 Pole Female - 5mm & 8mm Wire",
    slug: "special-al-3-pole-female-5-8mm",
    category: "Special Universal Connectors",
    subcategory: "3 Pole Connectors",
    description: "Universal Ashok Leyland 3 pole female connector with 5mm & 8mm deluxe wire.",
    partNumber: "SH2100311",
    image: "/products/special-universal-connectors/special-universal/SH2100311.jpg",
    featured: true,
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Compatible": "Universal Ashok Leyland",
      "Wire Type": "5mm & 8mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "3-pole", "ashok-leyland", "female"],
    applications: ["Ashok Leyland"],
  },
  {
    id: "special-conn-al-3p-m-5-8mm",
    name: "Universal Ashok Leyland 3 Pole Male - 5mm & 8mm Wire",
    slug: "special-al-3-pole-male-5-8mm",
    category: "Special Universal Connectors",
    subcategory: "3 Pole Connectors",
    description: "Universal Ashok Leyland 3 pole male connector with 5mm & 8mm deluxe wire.",
    partNumber: "SH2100312",
    image: "/products/special-universal-connectors/special-universal/SH2100312.jpg",
    featured: true,
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Male",
      "Compatible": "Universal Ashok Leyland",
      "Wire Type": "5mm & 8mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "3-pole", "ashok-leyland", "male"],
    applications: ["Ashok Leyland"],
  },
  {
    id: "special-conn-universal-tata-3p-f-5-8mm",
    name: "Universal Tata 3 Pole Female - 5mm & 8mm Wire",
    slug: "special-universal-tata-3-pole-female-5-8mm",
    category: "Special Universal Connectors",
    subcategory: "3 Pole Connectors",
    description: "Universal Tata 3 pole female connector with 5mm & 8mm deluxe wire.",
    partNumber: "SH2100313",
    image: "/products/special-universal-connectors/special-universal/SH2100313.jpg",
    featured: true,
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Compatible": "Universal Tata",
      "Wire Type": "5mm & 8mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "3-pole", "universal", "tata", "female"],
    applications: ["Tata Vehicles"],
  },
  {
    id: "special-conn-universal-tata-3p-m-5-8mm",
    name: "Universal Tata 3 Pole Male - 5mm & 8mm Wire",
    slug: "special-universal-tata-3-pole-male-5-8mm",
    category: "Special Universal Connectors",
    subcategory: "3 Pole Connectors",
    description: "Universal Tata 3 pole male connector with 5mm & 8mm deluxe wire.",
    partNumber: "SH2100314",
    image: "/products/special-universal-connectors/special-universal/SH2100314.jpg",
    featured: true,
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Male",
      "Compatible": "Universal Tata",
      "Wire Type": "5mm & 8mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "3-pole", "universal", "tata", "male"],
    applications: ["Tata Vehicles"],
  },
  {
    id: "special-conn-oxygen-sensor-santro-3p-f",
    name: "Oxygen Sensor Santro Xing 3 Pole Female",
    slug: "special-oxygen-sensor-santro-xing-3-pole-female",
    category: "Special Universal Connectors",
    subcategory: "3 Pole Connectors",
    description: "Oxygen sensor for Santro Xing 3 pole female connector with 4mm deluxe wire.",
    partNumber: "SH2100318",
    image: "/products/special-universal-connectors/special-universal/SH2100318.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Compatible": "Santro Xing Oxygen Sensor",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "3-pole", "santro", "oxygen-sensor", "female"],
    applications: ["Santro Xing", "Oxygen Sensor"],
  },
  {
    id: "special-conn-thermoswitch-maruti-maximo-3p-f",
    name: "Thermoswitch Maruti & Mahindra Maximo 3 Pole Female",
    slug: "special-thermoswitch-maruti-maximo-3-pole-female",
    category: "Special Universal Connectors",
    subcategory: "3 Pole Connectors",
    description: "Thermoswitch for Maruti & Mahindra Maximo 3 pole female connector with special wire.",
    partNumber: "SH2100320",
    image: "/products/special-universal-connectors/special-universal/SH2100320.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Compatible": "Maruti & Mahindra Maximo Thermoswitch",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "3-pole", "maruti", "maximo", "thermoswitch", "female"],
    applications: ["Maruti", "Mahindra Maximo", "Thermoswitch"],
  },
  {
    id: "special-conn-alto-wagonr-alternator-3p-f",
    name: "Alto/Wagon-R Alternator K Series 3 Pole Female",
    slug: "special-alto-wagonr-alternator-kseries-3-pole-female",
    category: "Special Universal Connectors",
    subcategory: "3 Pole Connectors",
    description: "Alternator for Alto/Wagon-R K Series 3 pole female connector with special wire.",
    partNumber: "SH2100321",
    image: "/products/special-universal-connectors/special-universal/SH2100321.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Compatible": "Alto/Wagon-R K Series Alternator",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "3-pole", "alto", "wagonr", "alternator", "k-series", "female"],
    applications: ["Maruti Alto", "Wagon-R", "Alternator"],
  },
  {
    id: "special-conn-tata-magic-3p-f",
    name: "Tata Magic 3 Pole Female",
    slug: "special-tata-magic-3-pole-female",
    category: "Special Universal Connectors",
    subcategory: "3 Pole Connectors",
    description: "Tata Magic 3 pole female connector with 4mm deluxe wire.",
    partNumber: "SH2100331",
    image: "/products/special-universal-connectors/special-universal/SH2100331.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Compatible": "Tata Magic",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "3-pole", "tata", "magic", "female"],
    applications: ["Tata Magic"],
  },
  {
    id: "special-conn-maximo-3p-f-special",
    name: "Mahindra Maximo 3 Pole Female - Special Wire",
    slug: "special-maximo-3-pole-female-special",
    category: "Special Universal Connectors",
    subcategory: "3 Pole Connectors",
    description: "Mahindra Maximo 3 pole female connector with special wire.",
    partNumber: "SH2100333",
    image: "/products/special-universal-connectors/special-universal/SH2100333.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Compatible": "Mahindra Maximo",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "3-pole", "maximo", "female"],
    applications: ["Mahindra Maximo"],
  },
  {
    id: "special-conn-speedometer-indica-3p-f",
    name: "Speedometer & Tata Indica Diesel 3 Pole Female",
    slug: "special-speedometer-indica-diesel-3-pole-female",
    category: "Special Universal Connectors",
    subcategory: "3 Pole Connectors",
    description: "Speedometer & Tata Indica Diesel 3 pole female connector with special wire.",
    partNumber: "SH2100334",
    image: "/products/special-universal-connectors/special-universal/SH2100334.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Compatible": "Tata Indica Diesel Speedometer",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "3-pole", "tata", "indica", "speedometer", "female"],
    applications: ["Tata Indica Diesel", "Speedometer"],
  },
  {
    id: "special-conn-speedometer-indica-3p-m",
    name: "Speedometer & Tata Indica Diesel 3 Pole Male",
    slug: "special-speedometer-indica-diesel-3-pole-male",
    category: "Special Universal Connectors",
    subcategory: "3 Pole Connectors",
    description: "Speedometer & Tata Indica Diesel 3 pole male connector with special wire.",
    partNumber: "SH2100337",
    image: "/products/special-universal-connectors/special-universal/SH2100337.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Male",
      "Compatible": "Tata Indica Diesel Speedometer",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "3-pole", "tata", "indica", "speedometer", "male"],
    applications: ["Tata Indica Diesel", "Speedometer"],
  },
  {
    id: "special-conn-maximo-3p-f-special-2",
    name: "Mahindra Maximo 3 Pole Female - Special Wire (Type 2)",
    slug: "special-maximo-3-pole-female-special-2",
    category: "Special Universal Connectors",
    subcategory: "3 Pole Connectors",
    description: "Mahindra Maximo 3 pole female connector with special wire.",
    partNumber: "SH2100341",
    image: "/products/special-universal-connectors/special-universal/SH2100341.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Compatible": "Mahindra Maximo",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "3-pole", "maximo", "female"],
    applications: ["Mahindra Maximo"],
  },
  {
    id: "special-conn-universal-tata-tp-sensor-3p-f",
    name: "Universal Tata TP Sensor Speedometer Tavera 3 Pole Female",
    slug: "special-universal-tata-tp-sensor-tavera-3-pole-female",
    category: "Special Universal Connectors",
    subcategory: "3 Pole Connectors",
    description: "Universal Tata TP sensor speedometer Tavera 3 pole female connector with special wire.",
    partNumber: "SH2100343",
    image: "/products/special-universal-connectors/special-universal/SH2100343.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Compatible": "Tata Tavera TP Sensor Speedometer",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "3-pole", "tata", "tavera", "tp-sensor", "speedometer", "female"],
    applications: ["Tata Tavera", "TP Sensor", "Speedometer"],
  },
  {
    id: "special-conn-universal-tata-3p-f-4-5mm",
    name: "Universal Tata 3 Pole Female - 4mm & 5mm Wire",
    slug: "special-universal-tata-3-pole-female-4-5mm",
    category: "Special Universal Connectors",
    subcategory: "3 Pole Connectors",
    description: "Universal Tata 3 pole female connector with 4mm & 5mm deluxe wire.",
    partNumber: "SH2100345",
    image: "/products/special-universal-connectors/special-universal/SH2100345.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Compatible": "Universal Tata",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "3-pole", "universal", "tata", "female"],
    applications: ["Tata Vehicles"],
  },
  {
    id: "special-conn-ignition-coil-alto-3p-f",
    name: "Ignition Coil Alto/Swift/Baleno/Wagon-R 3 Pole Female",
    slug: "special-ignition-coil-alto-swift-baleno-3-pole-female",
    category: "Special Universal Connectors",
    subcategory: "3 Pole Connectors",
    description: "Ignition coil for Alto/Swift/Baleno/Wagon-R 3 pole female connector with special wire.",
    partNumber: "SH2100347",
    image: "/products/special-universal-connectors/special-universal/SH2100347.jpg",
    featured: true,
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Compatible": "Alto/Swift/Baleno/Wagon-R Ignition Coil",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "3-pole", "alto", "swift", "baleno", "wagonr", "ignition-coil", "female"],
    applications: ["Maruti Alto", "Swift", "Baleno", "Wagon-R", "Ignition Coil"],
  },
  {
    id: "special-conn-ic-valve-maruti-3p-f-1",
    name: "IC Valve Maruti 3 Pole Female",
    slug: "special-ic-valve-maruti-3-pole-female-1",
    category: "Special Universal Connectors",
    subcategory: "3 Pole Connectors",
    description: "IC valve for Maruti 3 pole female connector with special wire.",
    partNumber: "SH2100348",
    image: "/products/special-universal-connectors/special-universal/SH2100348.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Compatible": "Maruti IC Valve",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "3-pole", "maruti", "ic-valve", "female"],
    applications: ["Maruti", "IC Valve"],
  },
  {
    id: "special-conn-ic-valve-maruti-3p-f-2",
    name: "IC Valve Maruti 3 Pole Female - Special Wire (Type 2)",
    slug: "special-ic-valve-maruti-3-pole-female-2",
    category: "Special Universal Connectors",
    subcategory: "3 Pole Connectors",
    description: "IC valve for Maruti 3 pole female connector with special wire.",
    partNumber: "SH2100349",
    image: "/products/special-universal-connectors/special-universal/SH2100349.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Compatible": "Maruti IC Valve",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "3-pole", "maruti", "ic-valve", "female"],
    applications: ["Maruti", "IC Valve"],
  },
  {
    id: "special-conn-tata-3p-f-special",
    name: "Tata 3 Pole Female - Special Wire",
    slug: "special-tata-3-pole-female-special",
    category: "Special Universal Connectors",
    subcategory: "3 Pole Connectors",
    description: "Tata 3 pole female connector with special wire.",
    partNumber: "SH2100350",
    image: "/products/special-universal-connectors/special-universal/SH2100350.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Compatible": "Tata",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "3-pole", "tata", "female"],
    applications: ["Tata Vehicles"],
  },
  {
    id: "special-conn-tata-3p-f-special-2",
    name: "Tata 3 Pole Female - Special Wire (Type 2)",
    slug: "special-tata-3-pole-female-special-2",
    category: "Special Universal Connectors",
    subcategory: "3 Pole Connectors",
    description: "Tata 3 pole female connector with special wire.",
    partNumber: "SH2100351",
    image: "/products/special-universal-connectors/special-universal/SH2100351.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Compatible": "Tata",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "3-pole", "tata", "female"],
    applications: ["Tata Vehicles"],
  },
  {
    id: "special-conn-tata-3p-f-special-3",
    name: "Tata 3 Pole Female - Special Wire (Type 3)",
    slug: "special-tata-3-pole-female-special-3",
    category: "Special Universal Connectors",
    subcategory: "3 Pole Connectors",
    description: "Tata 3 pole female connector with special wire.",
    partNumber: "SH2100352",
    image: "/products/special-universal-connectors/special-universal/SH2100352.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Compatible": "Tata",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "3-pole", "tata", "female"],
    applications: ["Tata Vehicles"],
  },
  {
    id: "special-conn-maximo-3p-f-ecm",
    name: "Mahindra Maximo 3 Pole Female - ECM Special Wire",
    slug: "special-maximo-3-pole-female-ecm",
    category: "Special Universal Connectors",
    subcategory: "3 Pole Connectors",
    description: "Mahindra Maximo 3 pole female connector with ECM special wire.",
    partNumber: "SH2100356",
    image: "/products/special-universal-connectors/special-universal/SH2100356.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Compatible": "Mahindra Maximo",
      "Wire Type": "ECM Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "3-pole", "maximo", "ecm", "female"],
    applications: ["Mahindra Maximo", "ECM"],
  },
  {
    id: "special-conn-universal-tata-3p-f-4mm",
    name: "Universal Tata 3 Pole Female - 4mm Wire",
    slug: "special-universal-tata-3-pole-female-4mm",
    category: "Special Universal Connectors",
    subcategory: "3 Pole Connectors",
    description: "Universal Tata 3 pole female connector with 4mm deluxe wire.",
    partNumber: "SH2100360",
    image: "/products/special-universal-connectors/special-universal/SH2100360.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Compatible": "Universal Tata",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "3-pole", "universal", "tata", "female"],
    applications: ["Tata Vehicles"],
  },
  {
    id: "special-conn-tata-3p-f-ecm",
    name: "Tata 3 Pole Female - ECM Special Wire",
    slug: "special-tata-3-pole-female-ecm",
    category: "Special Universal Connectors",
    subcategory: "3 Pole Connectors",
    description: "Tata 3 pole female connector with ECM special wire.",
    partNumber: "SH2100362",
    image: "/products/special-universal-connectors/special-universal/SH2100362.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Compatible": "Tata",
      "Wire Type": "ECM Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "3-pole", "tata", "ecm", "female"],
    applications: ["Tata", "ECM"],
  },
  {
    id: "special-conn-tata-3p-f-6-8mm",
    name: "Tata 3 Pole Female - 6mm & 8mm Wire",
    slug: "special-tata-3-pole-female-6-8mm",
    category: "Special Universal Connectors",
    subcategory: "3 Pole Connectors",
    description: "Tata 3 pole female connector with 6mm & 8mm deluxe wire.",
    partNumber: "SH2100375",
    image: "/products/special-universal-connectors/special-universal/SH2100375.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Compatible": "Tata",
      "Wire Type": "6mm & 8mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "3-pole", "tata", "female"],
    applications: ["Tata Vehicles"],
  },
  {
    id: "special-conn-tata-3p-m-6-8mm",
    name: "Tata 3 Pole Male - 6mm & 8mm Wire",
    slug: "special-tata-3-pole-male-6-8mm",
    category: "Special Universal Connectors",
    subcategory: "3 Pole Connectors",
    description: "Tata 3 pole male connector with 6mm & 8mm deluxe wire.",
    partNumber: "SH2100376",
    image: "/products/special-universal-connectors/special-universal/SH2100376.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Male",
      "Compatible": "Tata",
      "Wire Type": "6mm & 8mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "3-pole", "tata", "male"],
    applications: ["Tata Vehicles"],
  },
  {
    id: "special-conn-al-new-model-3p-f",
    name: "New Model Ashok Leyland 3 Pole Female",
    slug: "special-al-new-model-3-pole-female",
    category: "Special Universal Connectors",
    subcategory: "3 Pole Connectors",
    description: "New model Ashok Leyland 3 pole female connector with 4mm deluxe wire.",
    partNumber: "SH2100380",
    image: "/products/special-universal-connectors/special-universal/SH2100380.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland New Model",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "3-pole", "ashok-leyland", "new-model", "female"],
    applications: ["Ashok Leyland New Model"],
  },
  {
    id: "special-conn-al-3p-f-5mm",
    name: "Ashok Leyland 3 Pole Female - 5mm Wire",
    slug: "special-al-3-pole-female-5mm",
    category: "Special Universal Connectors",
    subcategory: "3 Pole Connectors",
    description: "Ashok Leyland 3 pole female connector with 5mm deluxe wire.",
    partNumber: "SH2100382",
    image: "/products/special-universal-connectors/special-universal/SH2100382.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland",
      "Wire Type": "5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "3-pole", "ashok-leyland", "female"],
    applications: ["Ashok Leyland"],
  },
  {
    id: "special-conn-universal-3p-f-4mm",
    name: "Universal 3 Pole Female - 4mm Wire",
    slug: "special-universal-3-pole-female-4mm",
    category: "Special Universal Connectors",
    subcategory: "3 Pole Connectors",
    description: "Universal 3 pole female connector with 4mm deluxe wire.",
    partNumber: "SH2100384",
    image: "/products/special-universal-connectors/special-universal/SH2100384.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "3-pole", "universal", "female"],
    applications: ["Universal Applications"],
  },
  {
    id: "special-conn-al-3p-f-ecm",
    name: "Ashok Leyland 3 Pole Female - ECM Special Wire",
    slug: "special-al-3-pole-female-ecm",
    category: "Special Universal Connectors",
    subcategory: "3 Pole Connectors",
    description: "Ashok Leyland 3 pole female connector with ECM special wire.",
    partNumber: "SH2100386",
    image: "/products/special-universal-connectors/special-universal/SH2100386.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland",
      "Wire Type": "ECM Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "3-pole", "ashok-leyland", "ecm", "female"],
    applications: ["Ashok Leyland", "ECM"],
  },
  {
    id: "special-conn-universal-3p-f-wire",
    name: "Universal 3 Pole Female - Wire",
    slug: "special-universal-3-pole-female-wire",
    category: "Special Universal Connectors",
    subcategory: "3 Pole Connectors",
    description: "Universal 3 pole female connector with wire.",
    partNumber: "SH2100389",
    image: "/products/special-universal-connectors/special-universal/SH2100389.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Wire Type": "Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "3-pole", "universal", "female"],
    applications: ["Universal Applications"],
  },
  {
    id: "special-conn-tata-3p-f-special-4",
    name: "Tata 3 Pole Female - Special Wire (Type 4)",
    slug: "special-tata-3-pole-female-special-4",
    category: "Special Universal Connectors",
    subcategory: "3 Pole Connectors",
    description: "Tata 3 pole female connector with special wire.",
    partNumber: "SH2100390",
    image: "/products/special-universal-connectors/special-universal/SH2100390.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Compatible": "Tata",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "3-pole", "tata", "female"],
    applications: ["Tata Vehicles"],
  },
  {
    id: "special-conn-universal-3p-f-special",
    name: "Universal 3 Pole Female - Special Wire",
    slug: "special-universal-3-pole-female-special",
    category: "Special Universal Connectors",
    subcategory: "3 Pole Connectors",
    description: "Universal 3 pole female connector with special wire.",
    partNumber: "SH2100463",
    image: "/products/special-universal-connectors/special-universal/SH2100463.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "3-pole", "universal", "female"],
    applications: ["Universal Applications"],
  },
];

// 4 POLE SPECIAL CONNECTORS  
export const specialConnector4PoleProducts: Product[] = [
  {
    id: "special-conn-high-pressure-switch-innova-4p-f",
    name: "High Pressure Switch Innova 4 Pole Female",
    slug: "special-high-pressure-switch-innova-4-pole-female",
    category: "Special Universal Connectors",
    subcategory: "4 Pole Connectors",
    description: "High pressure switch for Innova 4 pole female connector with 4mm deluxe wire.",
    partNumber: "SH2100411",
    image: "/products/special-universal-connectors/special-universal/SH2100411.jpg",
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Female",
      "Compatible": "Innova High Pressure Switch",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "4-pole", "innova", "high-pressure-switch", "female"],
    applications: ["Toyota Innova", "AC High Pressure Switch"],
  },
  {
    id: "special-conn-tata-ace-4p-f",
    name: "Tata ACE 4 Pole Female",
    slug: "special-tata-ace-4-pole-female",
    category: "Special Universal Connectors",
    subcategory: "4 Pole Connectors",
    description: "Tata ACE 4 pole female connector with 4mm deluxe wire.",
    partNumber: "SH2100413",
    image: "/products/special-universal-connectors/special-universal/SH2100413.jpg",
    featured: true,
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Female",
      "Compatible": "Tata ACE",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "4-pole", "tata", "ace", "female"],
    applications: ["Tata ACE"],
  },
  {
    id: "special-conn-maximo-4p-f-4mm",
    name: "Mahindra Maximo 4 Pole Female - 4mm Wire",
    slug: "special-maximo-4-pole-female-4mm",
    category: "Special Universal Connectors",
    subcategory: "4 Pole Connectors",
    description: "Mahindra Maximo 4 pole female connector with 4mm deluxe wire.",
    partNumber: "SH2100421",
    image: "/products/special-universal-connectors/special-universal/SH2100421.jpg",
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Female",
      "Compatible": "Mahindra Maximo",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "4-pole", "maximo", "female"],
    applications: ["Mahindra Maximo"],
  },
  {
    id: "special-conn-4p-f-special",
    name: "Universal 4 Pole Female - Special Wire",
    slug: "special-universal-4-pole-female-special",
    category: "Special Universal Connectors",
    subcategory: "4 Pole Connectors",
    description: "Universal 4 pole female connector with special wire.",
    partNumber: "SH2100423",
    image: "/products/special-universal-connectors/special-universal/SH2100423.jpg",
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Female",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "4-pole", "universal", "female"],
    applications: ["Universal Applications"],
  },
  {
    id: "special-conn-4p-m-special",
    name: "Universal 4 Pole Male - Special Wire",
    slug: "special-universal-4-pole-male-special",
    category: "Special Universal Connectors",
    subcategory: "4 Pole Connectors",
    description: "Universal 4 pole male connector with special wire.",
    partNumber: "SH2100424",
    image: "/products/special-universal-connectors/special-universal/SH2100424.jpg",
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Male",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "4-pole", "universal", "male"],
    applications: ["Universal Applications"],
  },
  {
    id: "special-conn-alternator-honda-innova-kseries-4p-f",
    name: "Alternator Honda/Innova/Maruti K Series 4 Pole Female",
    slug: "special-alternator-honda-innova-maruti-kseries-4-pole-female",
    category: "Special Universal Connectors",
    subcategory: "4 Pole Connectors",
    description: "Alternator for Honda/Innova/Maruti K Series 4 pole female connector with 4mm deluxe wire.",
    partNumber: "SH2100431",
    image: "/products/special-universal-connectors/special-universal/SH2100431.jpg",
    featured: true,
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Female",
      "Compatible": "Honda/Innova/Maruti K Series Alternator",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "4-pole", "honda", "innova", "maruti", "k-series", "alternator", "female"],
    applications: ["Honda", "Innova", "Maruti K Series", "Alternator"],
  },
  {
    id: "special-conn-maximo-4p-f-ecm",
    name: "Mahindra Maximo 4 Pole Female - ECM Special Wire",
    slug: "special-maximo-4-pole-female-ecm",
    category: "Special Universal Connectors",
    subcategory: "4 Pole Connectors",
    description: "Mahindra Maximo 4 pole female connector with ECM special wire.",
    partNumber: "SH2100456",
    image: "/products/special-universal-connectors/special-universal/SH2100456.jpg",
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Female",
      "Compatible": "Mahindra Maximo",
      "Wire Type": "ECM Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "4-pole", "maximo", "ecm", "female"],
    applications: ["Mahindra Maximo", "ECM"],
  },
  {
    id: "special-conn-al-4p-m-4mm",
    name: "Ashok Leyland 4 Pole Male - 4mm Wire",
    slug: "special-al-4-pole-male-4mm",
    category: "Special Universal Connectors",
    subcategory: "4 Pole Connectors",
    description: "Ashok Leyland 4 pole male connector with 4mm deluxe wire.",
    partNumber: "SH2100455",
    image: "/products/special-universal-connectors/special-universal/SH2100455.jpg",
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Male",
      "Compatible": "Ashok Leyland",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "4-pole", "ashok-leyland", "male"],
    applications: ["Ashok Leyland"],
  },
  {
    id: "special-conn-universal-tata-4p-f-4mm",
    name: "Universal Tata 4 Pole Female - 4mm Wire",
    slug: "special-universal-tata-4-pole-female-4mm",
    category: "Special Universal Connectors",
    subcategory: "4 Pole Connectors",
    description: "Universal Tata 4 pole female connector with 4mm deluxe wire.",
    partNumber: "SH2100461",
    image: "/products/special-universal-connectors/special-universal/SH2100461.jpg",
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Female",
      "Compatible": "Universal Tata",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "4-pole", "universal", "tata", "female"],
    applications: ["Tata Vehicles"],
  },
  {
    id: "special-conn-universal-al-4p-f-ecm",
    name: "Universal Ashok Leyland 4 Pole Female - ECM Special Wire",
    slug: "special-universal-al-4-pole-female-ecm",
    category: "Special Universal Connectors",
    subcategory: "4 Pole Connectors",
    description: "Universal Ashok Leyland 4 pole female connector with ECM special wire.",
    partNumber: "SH2100462",
    image: "/products/special-universal-connectors/special-universal/SH2100462.jpg",
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Female",
      "Compatible": "Universal Ashok Leyland",
      "Wire Type": "ECM Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "4-pole", "ashok-leyland", "ecm", "female"],
    applications: ["Ashok Leyland", "ECM"],
  },
  {
    id: "special-conn-universal-4p-f-4mm",
    name: "Universal 4 Pole Female - 4mm Wire",
    slug: "special-universal-4-pole-female-4mm",
    category: "Special Universal Connectors",
    subcategory: "4 Pole Connectors",
    description: "Universal 4 pole female connector with 4mm deluxe wire.",
    partNumber: "SH2100486",
    image: "/products/special-universal-connectors/special-universal/SH2100486.jpg",
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Female",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "4-pole", "universal", "female"],
    applications: ["Universal Applications"],
  },
  {
    id: "special-conn-al-4p-f-5mm-1",
    name: "Ashok Leyland 4 Pole Female - 5mm Wire (Type 1)",
    slug: "special-al-4-pole-female-5mm-1",
    category: "Special Universal Connectors",
    subcategory: "4 Pole Connectors",
    description: "Ashok Leyland 4 pole female connector with 5mm deluxe wire.",
    partNumber: "SH2100487",
    image: "/products/special-universal-connectors/special-universal/SH2100487.jpg",
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland",
      "Wire Type": "5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "4-pole", "ashok-leyland", "female"],
    applications: ["Ashok Leyland"],
  },
  {
    id: "special-conn-al-4p-f-5mm-2",
    name: "Ashok Leyland 4 Pole Female - 5mm Wire (Type 2)",
    slug: "special-al-4-pole-female-5mm-2",
    category: "Special Universal Connectors",
    subcategory: "4 Pole Connectors",
    description: "Ashok Leyland 4 pole female connector with 5mm deluxe wire.",
    partNumber: "SH2100488",
    image: "/products/special-universal-connectors/special-universal/SH2100488.jpg",
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland",
      "Wire Type": "5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "4-pole", "ashok-leyland", "female"],
    applications: ["Ashok Leyland"],
  },
  {
    id: "special-conn-al-4p-f-5mm-3",
    name: "Ashok Leyland 4 Pole Female - 5mm Wire (Type 3)",
    slug: "special-al-4-pole-female-5mm-3",
    category: "Special Universal Connectors",
    subcategory: "4 Pole Connectors",
    description: "Ashok Leyland 4 pole female connector with 5mm deluxe wire.",
    partNumber: "SH2100489",
    image: "/products/special-universal-connectors/special-universal/SH2100489.jpg",
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland",
      "Wire Type": "5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "4-pole", "ashok-leyland", "female"],
    applications: ["Ashok Leyland"],
  },
  {
    id: "special-conn-universal-4p-m-4mm",
    name: "Universal 4 Pole Male - 4mm Wire",
    slug: "special-universal-4-pole-male-4mm",
    category: "Special Universal Connectors",
    subcategory: "4 Pole Connectors",
    description: "Universal 4 pole male connector with 4mm deluxe wire.",
    partNumber: "SH2100490",
    image: "/products/special-universal-connectors/special-universal/SH2100490.jpg",
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Male",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "4-pole", "universal", "male"],
    applications: ["Universal Applications"],
  },
  {
    id: "special-conn-tata-indica-4p-f-8mm",
    name: "Tata Indica 4 Pole Female - 8mm Wire",
    slug: "special-tata-indica-4-pole-female-8mm",
    category: "Special Universal Connectors",
    subcategory: "4 Pole Connectors",
    description: "Tata Indica 4 pole female connector with 8mm deluxe wire.",
    partNumber: "SH2100491",
    image: "/products/special-universal-connectors/special-universal/SH2100491.jpg",
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Female",
      "Compatible": "Tata Indica",
      "Wire Type": "8mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "4-pole", "tata", "indica", "female"],
    applications: ["Tata Indica"],
  },
  {
    id: "special-conn-tata-indica-4p-m-8mm",
    name: "Tata Indica 4 Pole Male - 8mm Wire",
    slug: "special-tata-indica-4-pole-male-8mm",
    category: "Special Universal Connectors",
    subcategory: "4 Pole Connectors",
    description: "Tata Indica 4 pole male connector with 8mm deluxe wire.",
    partNumber: "SH2100493",
    image: "/products/special-universal-connectors/special-universal/SH2100493.jpg",
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Male",
      "Compatible": "Tata Indica",
      "Wire Type": "8mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "4-pole", "tata", "indica", "male"],
    applications: ["Tata Indica"],
  },
  {
    id: "special-conn-al-4p-f-special",
    name: "Ashok Leyland 4 Pole Female - Special Wire",
    slug: "special-al-4-pole-female-special",
    category: "Special Universal Connectors",
    subcategory: "4 Pole Connectors",
    description: "Ashok Leyland 4 pole female connector with special wire.",
    partNumber: "SH2100494",
    image: "/products/special-universal-connectors/special-universal/SH2100494.jpg",
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "4-pole", "ashok-leyland", "female"],
    applications: ["Ashok Leyland"],
  },
  {
    id: "special-conn-al-4p-f-4mm",
    name: "Ashok Leyland 4 Pole Female - 4mm Wire",
    slug: "special-al-4-pole-female-4mm",
    category: "Special Universal Connectors",
    subcategory: "4 Pole Connectors",
    description: "Ashok Leyland 4 pole female connector with 4mm deluxe wire.",
    partNumber: "SH2100495",
    image: "/products/special-universal-connectors/special-universal/SH2100495.jpg",
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "4-pole", "ashok-leyland", "female"],
    applications: ["Ashok Leyland"],
  },
  {
    id: "special-conn-tata-4p-f-special",
    name: "Tata 4 Pole Female - Special Wire",
    slug: "special-tata-4-pole-female-special",
    category: "Special Universal Connectors",
    subcategory: "4 Pole Connectors",
    description: "Tata 4 pole female connector with special wire.",
    partNumber: "SH2100496",
    image: "/products/special-universal-connectors/special-universal/SH2100496.jpg",
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Female",
      "Compatible": "Tata",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "4-pole", "tata", "female"],
    applications: ["Tata Vehicles"],
  },
  {
    id: "special-conn-universal-4p-f-4mm-2",
    name: "Universal 4 Pole Female - 4mm Wire (Type 2)",
    slug: "special-universal-4-pole-female-4mm-2",
    category: "Special Universal Connectors",
    subcategory: "4 Pole Connectors",
    description: "Universal 4 pole female connector with 4mm deluxe wire.",
    partNumber: "SH2100497",
    image: "/products/special-universal-connectors/special-universal/SH2100497.jpg",
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Female",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "4-pole", "universal", "female"],
    applications: ["Universal Applications"],
  },
  {
    id: "special-conn-al-tata-new-model-4p-ecm",
    name: "Ashok Leyland & Tata New Model 4 Pole - ECM Wire",
    slug: "special-al-tata-new-model-4-pole-ecm",
    category: "Special Universal Connectors",
    subcategory: "4 Pole Connectors",
    description: "Ashok Leyland & Tata new model 4 pole connector with ECM wire.",
    partNumber: "SH2100498",
    image: "/products/special-universal-connectors/special-universal/SH2100498.jpg",
    specifications: {
      "Poles": "4 Pole",
      "Compatible": "Ashok Leyland & Tata New Model",
      "Wire Type": "ECM Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "4-pole", "ashok-leyland", "tata", "new-model", "ecm"],
    applications: ["Ashok Leyland New Model", "Tata New Model", "ECM"],
  },
  {
    id: "special-conn-al-4p-f-4mm-2",
    name: "Ashok Leyland 4 Pole Female - 4mm Wire (Type 2)",
    slug: "special-al-4-pole-female-4mm-2",
    category: "Special Universal Connectors",
    subcategory: "4 Pole Connectors",
    description: "Ashok Leyland 4 pole female connector with 4mm deluxe wire.",
    partNumber: "SH2100499",
    image: "/products/special-universal-connectors/special-universal/SH2100499.jpg",
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "4-pole", "ashok-leyland", "female"],
    applications: ["Ashok Leyland"],
  },
];
